import { WebRNModuleAPIs } from 'src/components/15-containers/SuperChargedWebView/communication/web2RNCom/WebRNModuleAPIs';
export class ReactNativeImageCacheAdapter {
    async isSupported() {
        return typeof WebRNModuleAPIs?.ImageCache !== 'undefined';
    }
    async cacheImage(url) {
        try {
            const result = await WebRNModuleAPIs.ImageCache.cacheImage(url);
            return result.success;
        }
        catch (error) {
            WebRNModuleAPIs.Logger.error('Failed to cache image via RN bridge:', error);
            return false;
        }
    }
    async cacheImages(urls) {
        try {
            const result = await WebRNModuleAPIs.ImageCache.cacheImages(urls);
            return result.results;
        }
        catch (error) {
            WebRNModuleAPIs.Logger.error('Failed to cache multiple images via RN bridge:', error);
            return urls.reduce((acc, url) => ({ ...acc, [url]: false }), {});
        }
    }
    async isCached(url) {
        try {
            const result = await WebRNModuleAPIs.ImageCache.isCached(url);
            return result.cached;
        }
        catch (error) {
            WebRNModuleAPIs.Logger.error('Failed to check cache status via RN bridge:', error);
            return false;
        }
    }
    async clearCache() {
        try {
            await WebRNModuleAPIs.ImageCache.clearCache();
        }
        catch (error) {
            WebRNModuleAPIs.Logger.error('Failed to clear cache via RN bridge:', error);
        }
    }
    async uncacheImage(url) {
        try {
            const result = await WebRNModuleAPIs.ImageCache.uncacheImage(url);
            return result.success;
        }
        catch (error) {
            WebRNModuleAPIs.Logger.error('Failed to uncache image via RN bridge:', error);
            return false;
        }
    }
}
